import React, { createContext, useContext, useState, useCallback } from "react";

const dict = {
  id: {
    dashboard: "Dashboard",
    price_list: "Daftar Harga",
    input_edit_price: "Input / Edit Harga",
    purchase_order: "PO & Rekap Kuota",
    input_edit_po: "Input / Edit PO",
    billing_invoice: "Buat Tagihan / Faktur",
    billing_list: "Daftar Tagihan & Pembayaran",
    input_sj: "Input Surat Jalan",
    sj_recap: "Rekap Surat Jalan",
    input_stock: "Input / Edit Stok",
    stock_items: "Stok Barang",
    stock_log: "Log Stok",
    expenses: "Catat Pengeluaran",
    expense_recap: "Rekap Pengeluaran",
    pnl: "Laporan Laba/Rugi",
    settings: "Pengaturan Database",
    users: "Manajemen User",
    pending_signups: "Pendaftaran Klien",
    agent_inbox: "Inbox Chat Agen",
    logs: "Log Sistem",
    chat: "Chat",
    quotations: "Penawaran Harga",
    logout: "Keluar",
    login: "Masuk",
    cash_in: "Kas Masuk",
    cash_out: "Kas Keluar",
    net_profit: "Laba Bersih",
    receivables: "Piutang Perusahaan",
    payables: "Hutang Perusahaan",
    po_progress: "Progres PO",
    latest_sj: "Surat Jalan Terbaru",
    alerts: "Notifikasi & Peringatan",
    monthly_reset: "Direset Bulanan",
    continuous: "Tidak direset",
    save: "Simpan",
    cancel: "Batal",
    add: "Tambah",
    edit: "Ubah",
    delete: "Hapus",
    print: "Cetak",
    search: "Cari",
    actions: "Aksi",
    no: "No",
    delivery_location: "Lokasi Pengiriman",
    material_name: "Nama Material",
    unit: "Satuan",
    price_non_vat: "Harga Non PPN",
    price_ex_vat: "Harga Exc PPN",
    price_with_vat: "Harga + PPN",
    delivery_cost: "Biaya Kirim",
    unloading_fee: "Biaya Bongkar",
    category: "Kategori",
    contract_date: "Tanggal Kontrak",
    client_name: "Nama Klien",
    quantity: "Jumlah",
    unit_price: "Harga Satuan",
    total: "Total",
    notes: "Catatan",
    upload_file: "Unggah File",
    po_number: "No PO",
    vehicle_no: "No Kendaraan",
    use_vat: "Gunakan PPN",
    discount: "Diskon",
    pph: "PPH",
    down_payment: "Uang Muka",
    grand_total: "Grand Total",
    paid: "Lunas",
    unpaid: "Belum Lunas",
    partial: "Sebagian",
    delivered: "Terkirim",
    undelivered: "Belum Kirim",
    billed: "Sudah Ditagih",
    unbilled: "Belum Ditagih",
    welcome: "Selamat datang kembali",
    email: "Email",
    password: "Kata sandi",
    role: "Role",
    name: "Nama",
    create_user: "Buat User",
    new_role: "Buat Role Baru",
    permissions: "Hak Akses",
    config_stage: "Konfigurasi",
    items_stage: "Item",
    preview_stage: "Preview",
    confirm_stage: "Konfirmasi",
    next: "Lanjut",
    back: "Kembali",
    finish: "Selesai",
    record_payment: "Catat Pembayaran",
    low_stock: "Stok Rendah",
    threshold: "Batas Minimum",
    revenue: "Pendapatan",
    expense: "Pengeluaran",
    period: "Periode",
    paid_amount: "Jumlah Bayar",
    payment_date: "Tanggal Bayar",
    method: "Metode",
    proof: "Bukti",
    vendor: "Vendor",
  },
  en: {
    dashboard: "Dashboard",
    price_list: "Price List",
    input_edit_price: "Input / Edit Price",
    purchase_order: "PO & Quota Recap",
    input_edit_po: "Input / Edit PO",
    billing_invoice: "Create Billing / Invoice",
    billing_list: "Billing & Payment List",
    input_sj: "Input Surat Jalan",
    sj_recap: "Surat Jalan Recap",
    input_stock: "Input / Edit Stock",
    stock_items: "Stock Items",
    stock_log: "Stock Log",
    expenses: "Record Expenses",
    expense_recap: "Expense Recap",
    pnl: "Profit & Loss Report",
    settings: "Database Settings",
    users: "User Management",
    pending_signups: "Pending Signups",
    agent_inbox: "Agent Chat Inbox",
    logs: "System Logs",
    chat: "Chat",
    quotations: "Quotations",
    logout: "Log out",
    login: "Sign in",
    cash_in: "Cash In",
    cash_out: "Cash Out",
    net_profit: "Net Profit",
    receivables: "Receivables",
    payables: "Payables (Debt)",
    po_progress: "PO Progress",
    latest_sj: "Latest Surat Jalan",
    alerts: "Alerts & Notifications",
    monthly_reset: "Resets monthly",
    continuous: "Continuous",
    save: "Save",
    cancel: "Cancel",
    add: "Add",
    edit: "Edit",
    delete: "Delete",
    print: "Print",
    search: "Search",
    actions: "Actions",
    no: "No",
    delivery_location: "Delivery Location",
    material_name: "Material Name",
    unit: "Unit",
    price_non_vat: "Non-VAT Price",
    price_ex_vat: "Ex-VAT Price",
    price_with_vat: "Price + VAT",
    delivery_cost: "Delivery Cost",
    unloading_fee: "Unloading Fee",
    category: "Category",
    contract_date: "Contract Date",
    client_name: "Client Name",
    quantity: "Quantity",
    unit_price: "Unit Price",
    total: "Total",
    notes: "Notes",
    upload_file: "Upload File",
    po_number: "PO Number",
    vehicle_no: "Vehicle No",
    use_vat: "Use VAT (PPN)",
    discount: "Discount",
    pph: "PPH",
    down_payment: "Down Payment (Uang Muka)",
    grand_total: "Grand Total",
    paid: "Paid",
    unpaid: "Unpaid",
    partial: "Partial",
    delivered: "Delivered",
    undelivered: "Undelivered",
    billed: "Billed",
    unbilled: "Unbilled",
    welcome: "Welcome back",
    email: "Email",
    password: "Password",
    role: "Role",
    name: "Name",
    create_user: "Create User",
    new_role: "Create New Role",
    permissions: "Permissions",
    config_stage: "Configuration",
    items_stage: "Items",
    preview_stage: "Preview",
    confirm_stage: "Confirm",
    next: "Next",
    back: "Back",
    finish: "Finish",
    record_payment: "Record Payment",
    low_stock: "Low Stock",
    threshold: "Threshold",
    revenue: "Revenue",
    expense: "Expense",
    period: "Period",
    paid_amount: "Paid Amount",
    payment_date: "Payment Date",
    method: "Method",
    proof: "Proof",
    vendor: "Vendor",
  },
};

const LangCtx = createContext(null);

export function LangProvider({ children }) {
  const [lang, setLang] = useState(() => localStorage.getItem("lang") || "id");
  const toggle = useCallback(() => {
    const next = lang === "id" ? "en" : "id";
    localStorage.setItem("lang", next);
    setLang(next);
  }, [lang]);
  const t = useCallback((key) => (dict[lang] && dict[lang][key]) || key, [lang]);
  return <LangCtx.Provider value={{ lang, setLang, toggle, t }}>{children}</LangCtx.Provider>;
}

export function useLang() {
  const ctx = useContext(LangCtx);
  if (!ctx) throw new Error("useLang must be used inside LangProvider");
  return ctx;
}
